import React, {Dispatch, FC, SetStateAction, useMemo, useState} from 'react';
import { BlueButton } from '../BlueButton';
import { Button } from '../../ContactsPage/Button';
import { Notification, Person} from '../../../types/global/types';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { UpdateAddedPersonNotification } from '../../Notifications/UpdateAddedPersonNotification';
import * as Yup from 'yup';
import { personSchema } from '../../../validationSchemas/personSchema';
import {generalActions} from '../../../backend/store/reducers/generalReducer';
import {actions as notificationActions} from '../../../backend/store/reducers/notificationsReducer';
import {
    confirmUpdateAddedPersonNotification
} from '../../../backend/store/actions/creators/confirmUpdateAddedPersonNotification';
import {updateAddedPersonNotification} from '../../../backend/store/actions/creators/updateAddedPersonNotification';
import { useTranslation } from '../../../hooks/useTranslation';

interface INewContactNotificationProps {
    notification: Notification,
    setSelectedNotification: Dispatch<SetStateAction<Notification | null>>
}

export const NewContactNotification: FC<INewContactNotificationProps> = ({ notification, setSelectedNotification }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const storedSalutations = useSelector(
        (state: any) => state.personsStore.salutations
    )

    const storedAddressesTypes = useSelector(
        (state: any) => state.addressesStore.types
    )

    const salutations = useMemo(
        () => storedSalutations || [],
        [storedSalutations]
    )
    const addressesTypes = useMemo(
        () => storedAddressesTypes || [],
        [storedAddressesTypes]
    )

    const formik = useFormik<{ new_persons: Person[] }>({
        initialValues: { new_persons: (notification.notes as any)?.newPersons || notification.newPersons || [] },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            new_persons: Yup.array().of(personSchema)
        }),
        // "Save" persists the admin's edits to the draft AND then applies them and closes the
        // notification (one click saves + confirms + dismisses). The confirm uses the STORED
        // draft, so persisting first is what makes an edit — e.g. switching the address to
        // manual — actually take effect.
        onSubmit: (values) => {
            dispatch(updateAddedPersonNotification({
                id: notification.id,
                data: values.new_persons,
                onSuccess: () => {
                    dispatch(confirmUpdateAddedPersonNotification({
                        id: notification.id,
                        data: { new_persons: values.new_persons },
                        onSuccess: () => {
                            dispatch(generalActions.successAC({ message: "Success", type: "success" }))
                            dispatch(notificationActions.removeNotificationFromList(notification.id))
                            setIsVisibleModal(false)
                            setSelectedNotification(null)
                        },
                        onError: () => {
                            dispatch(generalActions.errorAC({ message: "Something went wrong", type: "error" }))
                        }
                    }))
                },
                onError: () => {
                    dispatch(generalActions.errorAC({ message: "Something went wrong", type: "error" }))
                }
            }))
        }
    });

    const handleConfirm = () => {
        dispatch(confirmUpdateAddedPersonNotification({
            id: notification.id,
            data: formik.values,
            onSuccess: () => {
                dispatch(generalActions.successAC({ message: "Success", type: "success" }));
                dispatch(notificationActions.removeNotificationFromList(notification.id));
                setSelectedNotification(null);
            },
            onError: () => {
                dispatch(generalActions.errorAC({ message: "Something went wrong", type: "error" }));
            }
        }))
    }


    const [isVisibleModal, setIsVisibleModal] = useState(false);
    return (
        <div className="notification"
        >
            <div className="notification__header">
                <div className="notification__title">
                    <h3>
                        {notification.title.startOfTitle}
                        {notification.title.householdName}
                        {notification.title.endOfTitle}
                    </h3>
                    <div className="notification__time">
                        {notification.created_at_formatted}
                    </div>
                </div>
            </div>

            <div className="notification__info">
                {t("notifications.view_and_change_info")}
            </div>
            <div className="notification__info-button">
                <BlueButton title={t("common.view_changed_information")} onClick={() => setIsVisibleModal(prevState => !prevState)} />
            </div>
            <div className="notification__button">
                <Button title={t("common.confirm_changes")} onClick={handleConfirm} />
            </div>
            <UpdateAddedPersonNotification
                isVisible={isVisibleModal}
                setIsVisible={() => {
                    setIsVisibleModal(prevState => !prevState)
                }}
                formik={formik}
                addressesTypes={addressesTypes}
                salutations={salutations}
            />
        </div>
    )
}